module.exports = __webpack_public_path__ + "static/media/Photo 2020-04-10, 7 44 45 AM.af73bb88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/testimonials/social/Photo 2020-04-10, 7 44 45 AM.jpg
// module id = 383
// module chunks = 0